import api from './api';

/**
 * Web Push v0 (ТЗ Part 2, раздел 8, редакция v1.1).
 *
 * Роуты именно /web-push/*, а не /notifications/web-push/* из v1.0 — последние
 * в production не существуют. user_id фронт не отправляет: backend связывает
 * подписку с авторизованным пользователем.
 */

/** 401 — не авторизован (это не «push недоступен»), 503 — VAPID не настроен. */
export const getWebPushPublicKey = () =>
  api.get('/web-push/public-key').then((response) => response.data);

export const getWebPushStatus = () =>
  api.get('/web-push/status').then((response) => response.data);

/** Идемпотентно по endpoint. 409 — конфликт endpoint между пользователями, 422 — невалидная подписка. */
export const subscribeWebPush = (subscription) =>
  api.post('/web-push/subscriptions', subscription).then((response) => response.data);

/** DELETE с телом: контракт v1.1 требует { endpoint }, а не id подписки в пути. */
export const unsubscribeWebPush = (endpoint) =>
  api.delete('/web-push/subscriptions', { data: { endpoint } }).then((response) => response.data);
